// Shared sort config for Be Aware > Negative Balance mobile.

export interface NegativeBalanceSortOption {
  label: string;
  value: string;
}

// Sort options mapped to the real Negative Balance API keys (mirrors the card metrics).
export const NEGATIVE_BALANCE_SORT_OPTIONS: NegativeBalanceSortOption[] = [
  { label: "Brand Name", value: "brand_names" },
  { label: "Calculated Total Income", value: "calculate_total_income" },
  { label: "Last Month End Balance", value: "balance_end_last_month" },
  { label: "Total Income", value: "totalincome_dollar" },
  { label: "CPA Income", value: "cpa_dollar" },
  { label: "RS Income", value: "revshare_dollar" },
  { label: "Click Out", value: "clicks" },
  { label: "Regs", value: "reg" },
  { label: "FTD", value: "ftd" },
  { label: "QFTD", value: "qftd" },
  { label: "Brand Policy Plan", value: "brand_policy_plan_name" },
];

// Keys that sort alphabetically; everything else sorts numerically.
const TEXT_SORT_KEYS = new Set(["brand_names", "brand_policy_plan_name"]);

// Default sort (mirrors the trigger label shown in the filter).
export const DEFAULT_NEGATIVE_BALANCE_SORT: {
  key: string;
  dir: "asc" | "desc";
} = {
  key: "brand_names",
  dir: "desc",
};

const cleanNumber = (value: any): number =>
  parseFloat(String(value ?? "0").replace(/[% ,$]/g, "")) || 0;

// Sort rows by the given key/direction. Text keys sort alphabetically,
// everything else numerically; null/undefined values always sink to the bottom.
export const sortNegativeBalanceRows = (
  rows: any[],
  key: string,
  dir: "asc" | "desc",
): any[] => {
  if (!key || !rows?.length) return rows ?? [];
  return [...rows].sort((a, b) => {
    const aRaw = a?.[key];
    const bRaw = b?.[key];
    if (aRaw == null && bRaw == null) return 0;
    if (aRaw == null) return 1;
    if (bRaw == null) return -1;
    if (TEXT_SORT_KEYS.has(key)) {
      return dir === "asc"
        ? String(aRaw).localeCompare(String(bRaw))
        : String(bRaw).localeCompare(String(aRaw));
    }
    const aNum = cleanNumber(aRaw);
    const bNum = cleanNumber(bRaw);
    return dir === "asc" ? aNum - bNum : bNum - aNum;
  });
};
